angular.module('bmsApp.settings').controller('EmailSettingsCtrl', [
	'$scope',
	'$log',
	'EmailSettingSvc',
	'AppSettingsSvc',
	'notify',
	'FranchiseSvc',
	'$q',
	'InstanceSvc',
	function ($scope, $log, EmailSettingSvc, AppSettingsSvc, notify, FranchiseSvc, $q, InstanceSvc) {


		$scope.tinymceOptions = {
			plugins: 'link image preview colorpicker',
			elementpath: false,
			statusbar : false,
			menu: {},
			height: "350",
			toolbar: 'bold italic fontsizeselect forecolor  alignleft aligncenter alignright  bullist numlist link image  undo redo  preview'
		};

		$scope.settingData = {};
		$scope.loaded = false;
		$scope.email = {};

		$scope.sslTypes = AppSettingsSvc.sslTypes();

		var promises = {
			email: EmailSettingSvc.read(),
			franchise: FranchiseSvc.read(),
			// settings: AppSettingsSvc.index(),
		};

		$q.all(promises).then(function(responses) {
			$scope.email = responses.email.data.email;
			$scope.settingData = {
				email_signature: responses.email.data.email_signature
			};
			$scope.franchise = responses.franchise.data.franchise;
			$scope.loaded = true;
		}, function(error) {
			$scope.errors = error;
		});


		$scope.generateEmailSignature = function() {

			var networkLogo = '';
			if (InstanceSvc.instance.isSM()) {
				networkLogo = 'https://s3-eu-west-1.amazonaws.com/bms-cdn/sm-clean-logo.png';
			}
			else if (InstanceSvc.instance.isTG()) {
				networkLogo = 'https://s3-eu-west-1.amazonaws.com/bms-cdn/tg-logo.png';
			}
			else if (InstanceSvc.instance.isMM()) {
				networkLogo = 'https://s3-eu-west-1.amazonaws.com/bms-cdn/mm-logo.png';
			}

			// find phone number
			var tel = email = mobile = '';
			var keepGoing = true;
			angular.forEach($scope.franchise.business_contact_details, function(detail) {
				if (detail.type.label == 'Phone (Work)' && keepGoing) {
					tel = detail.label;
					keepGoing = false;
				}
			});

			// mobile
			keepGoing = true; // reset
			angular.forEach($scope.franchise.business_contact_details, function(detail) {
				if (detail.type.label == 'Phone (Mobile)' && keepGoing) {
					mobile = detail.label;
					keepGoing = false;
				}
			});

			// email
			keepGoing = true; // reset
			angular.forEach($scope.franchise.business_contact_details, function(detail) {
				if (detail.type.group == 'email' && keepGoing) {
					email = detail.label;
					keepGoing = false;
				}
			});

			// if (InstanceSvc.instance.isSM()) {
				$scope.settingData.email_signature = '<p><span style=\"font-size: 10pt;\">!!replace_with_your_name_here!!</span></p>' +
					'<p><span style=\"font-size: 10pt;\">' + $scope.franchise.business_name + '</span></p>' +
					'<p><span style=\"font-size: 10pt;\">t: ' + tel + '</span></p>' +
					'<p><span style=\"font-size: 10pt;\">m: ' + mobile + '</span></p>' +
					'<p><span style=\"font-size: 10pt;\">e: <a href=\"mailto:' + email + '\">' + email + '</a></span></p>' +
					'<p><span style=\"font-size: 10pt;\"><img src=\"' + networkLogo + '\" width="162" /><br /></span></p>' +
					'<p>&nbsp;</p>' +
					'<p><span style=\"font-size: 8pt;color:gray\">This email and any files transmitted with it are confidential and intended solely for the use of the individual or entity to whom they are addressed. Please note that any views or opinions presented in this email are solely those of the author and do not necessarily represent those of ' + $scope.franchise.business_name + '. If you are not the intended recipient, be advised that you have received this e-mail in error and that any use, dissemination, forwarding, printing or copying of this e-mail is strictly prohibited. If you have received the e-mail in error please contact the sender.</span></p>';
			// }
		};


		$scope.submit = function () {
			var promises = {
				email: EmailSettingSvc.save({
					email_signature: $scope.settingData.email_signature
				})
			};
			$q.all(promises).then(function(responses) {
				notify({
					message: 'Email settings saved'
				});
				$scope.email = responses.email.data.email;
				$scope.settingData.email_signature = responses.email.data.email_signature;
			}, function(error) {
				$scope.errors = error;
			});


		}

	}]);
